import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ProductTile from '../../../shared/components/ProductTile/ProductTile';
import Analytics from '../../../analytics/Analytics';


const ProductTiles = function ProductTilesComponent({ products, productLimit, emptyCart }) {
  const tileClass = classNames({
    'cart-recommendations__tile': !emptyCart,
    'empty-cart-recommendations__tile': emptyCart,
  });

  return products.map((product, index) => {
    if (index < productLimit) {
      const track = {
        list: 'Cartpage Recommended Products',
        analytics: new Analytics(),
        measure: product,
      };

      return (
        <div key={product.id} className={tileClass}>
          <ProductTile product={product} track={track} />
        </div>
      );
    }
    return null;
  });
};

ProductTiles.propTypes = {
  emptyCart: PropTypes.bool,
  productLimit: PropTypes.number.isRequired,
  products: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

ProductTiles.defaultProps = {
  emptyCart: false,
};

export default ProductTiles;
